interface IconProps {
  className?: string;
}

/**
 * Star glyph, filled. Inlined instead of the shared sprite (~/components/Icon)
 * because that one renders without a `viewBox` and gets cropped when scaled
 * down via CSS.
 */
const StarIcon = ({ className }: IconProps) => (
  <svg viewBox="0 0 20 20" fill="none" aria-hidden className={className}>
    <path
      d="M9.10451 2.80165C9.47226 2.06177 10.5277 2.06177 10.8955 2.80165L12.5478 6.1259C12.6938 6.41979 12.9748 6.6233 13.2996 6.67044L16.9847 7.20536C17.8067 7.32468 18.1333 8.33622 17.5363 8.91375L14.8802 11.4829C14.6423 11.713 14.5337 12.0458 14.59 12.3719L15.2179 16.0073C15.3588 16.8233 14.5035 17.4472 13.7695 17.0638L10.4629 15.3369C10.1729 15.1855 9.8271 15.1855 9.53707 15.3369L6.2305 17.0638C5.49646 17.4472 4.64122 16.8233 4.78215 16.0073L5.40999 12.3719C5.4663 12.0458 5.35766 11.713 5.11983 11.4829L2.46374 8.91375C1.86667 8.33622 2.19327 7.32468 3.01534 7.20536L6.70041 6.67044C7.02519 6.6233 7.30617 6.41979 7.45224 6.1259L9.10451 2.80165Z"
      fill="currentColor"
    />
  </svg>
);

export default StarIcon;
